export default "__VITE_ASSET__BFpiQzYk__"